/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "insurance": {
            "nested": {
              "GetNextAffiliationIntegrationParametersRequest": {
                "fields": {}
              },
              "GetNextAffiliationIntegrationParametersResponse": {
                "fields": {
                  "signature": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timestamp": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "aggregatorName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "agentId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "NextAffiliationService": {
                "methods": {
                  "GetAffiliationIntegrationParameters": {
                    "requestType": ".squareup.bizbank.insurance.GetNextAffiliationIntegrationParametersRequest",
                    "responseType": ".squareup.bizbank.insurance.GetNextAffiliationIntegrationParametersResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.insurance?.nested?.GetNextAffiliationIntegrationParametersRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.insurance?.nested?.GetNextAffiliationIntegrationParametersResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.insurance?.nested?.NextAffiliationService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetNextAffiliationIntegrationParametersRequest @ squareup/bizbank/insurance/next_affiliation.proto at 10:1
 */
export const GetNextAffiliationIntegrationParametersRequest = $root.lookupType('squareup.bizbank.insurance.GetNextAffiliationIntegrationParametersRequest');
fixType(GetNextAffiliationIntegrationParametersRequest);
Builder.createAndAttachToType(GetNextAffiliationIntegrationParametersRequest);
/**
 * The required parameters listed at https://app.nextinsurance.com/guide/sdk
 *
 * SOURCE GetNextAffiliationIntegrationParametersResponse @ squareup/bizbank/insurance/next_affiliation.proto at 14:1
 */
export const GetNextAffiliationIntegrationParametersResponse = $root.lookupType('squareup.bizbank.insurance.GetNextAffiliationIntegrationParametersResponse');
fixType(GetNextAffiliationIntegrationParametersResponse, {
  signature: {
    required: true
  },
  timestamp: {
    required: true
  },
  aggregatorName: {
    required: true
  },
  agentId: {
    required: true
  }
});
Builder.createAndAttachToType(GetNextAffiliationIntegrationParametersResponse);
/**
 * SOURCE NextAffiliationService @ squareup/bizbank/insurance/next_affiliation.proto at 21:1
 */
export const NextAffiliationService = $root.lookupService('squareup.bizbank.insurance.NextAffiliationService');